import { useEffect } from 'react';
import { useMobileMediaQuery } from '../config/mediaQuery';

function useMenuHandler(handler, enabled, changeHandler = null) {
  const isMobile = useMobileMediaQuery();

  useEffect(() => {
    return () => {
      isMobile && document.removeEventListener("touchstart", handler);
    };
  }, []);

  useEffect(() => {
    if (isMobile && !enabled) {
      document.removeEventListener("touchstart", handler);
      changeHandler && changeHandler(false);
    } else if (isMobile && enabled) {
      document.addEventListener("touchstart", handler);
      changeHandler && changeHandler(true);
    }
  }, [enabled]);
}

export default useMenuHandler;
